import React from "react";
import Window from "./Window";
import GameRules from "./GameRules";

import "./HowToPlay.css";
import Common from "../Common";

export default class HowToPlay extends React.Component<HowToPlay.Props, HowToPlay.State>
{


    constructor(props: HowToPlay.Props)
    {
        super(props)
    }


    clickRules()
    {
        app.closeLastWindow();
        app.addWindow(<GameRules />);
    }


    render()
    {
        const data = window.lang.shared.modals["quick-help"];
        const lShared = window.lang.shared;

        return (
            <Window
                id="howToPlay"
                title={lShared.how_to_play + "?"}
            >
                <div className="video">
                    <video
                        src={Common.getVideoUrl()}
                        controls
                        preload="none"
                        poster="gfx/video_preview.png"
                        controlsList="nodownload"
                    />
                </div>

                <div className="item">
                    <div className="num icon_1">
                        01
                    </div>
                    <div className="label">
                        {data.step1}
                    </div>
                </div>

                <div className="item">
                    <div className="num icon_2">
                        02
                    </div>
                    <div className="label">
                        {data.step2}
                    </div>
                </div>

                <div className="item">
                    <div className="num icon_3">
                        03
                    </div>
                    <div className="label">
                        {data.step3}
                    </div>
                </div>

                <div className="footer">
                    <div
                        className="link"
                        onClick={this.clickRules.bind(this)}
                    >
                        {data.details}
                    </div>
                </div>
            </Window>
        )
    }


}


export namespace HowToPlay
{


    export interface Props
    {

    }


    export interface State
    {

    }


}